import type { CourseModule } from "@/core/types";
import { lektionTypWaehlen } from "./lektion-01-typ-waehlen";
import { lektionLesbar } from "./lektion-02-lesbar";
import { lektionKombidiagramm } from "./lektion-03-kombi";
import { lektionSparklines } from "./lektion-04-sparklines";

export const modulDiagramme: CourseModule = {
  id: "diagramme",
  title: "Diagramme",
  summary:
    "Den Typ aus der Frage ableiten, räumliche Verzerrung vermeiden und den Titel " +
    "als Aussage benutzen. Dazu Kombidiagramme, Trendlinien und Sparklines.",
  level: "Grundlagen",
  lessons: [lektionTypWaehlen, lektionLesbar, lektionKombidiagramm, lektionSparklines],
};
